export type CarriageTypeLangKey = "covered_carriage" | "refrigerator_carriage" | "half_carriage" | "transporter" | "tank_carriage";

export const fwlCarrigeTypeOptionKeys: Array<CarriageTypeLangKey> = [
  "covered_carriage",
  "refrigerator_carriage",
  "half_carriage",
  "transporter",
  "tank_carriage",
];
